<template>
  <div id="app" :key="appKey">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
    data(){
        return{
            appKey:1
        }
    },
    watch:{
        '$route'(to, from){
            this.appKey = new Date().getTime();
        }
    },
  }
</script>

<style>
  #app {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue